module.exports = __webpack_public_path__ + "img/015.23a4bb3b.jpg";